import React, { useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import EnquiryModal from "../../Components/EnquiryModal";
import "../../App.css";

import cross_arm from "../../Assets/cross_arm.jpg";

function Cross_arm() {
  const [showEnquiry, setShowEnquiry] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const openEnquiryModal = (product) => {
    setSelectedProduct(product);
    setShowEnquiry(true);
  };

  const products = [
    {
      id: 1,
      name: "Cross Arm",
      image: cross_arm,
      specs: {
        application: "Overhead Transmission & Distribution Lines",
        material: "Mild Steel",
        finish: "Hot Dip Galvanized",
        color: "Metallic Grey",
        warranty: "1 Year",
        supply: "8,000 Units / Month",
      },
    },
  ];

  return (
    <Container>
      <Row className="mt-5">
        {products.map((product) => (
          <Col md={6} key={product.id} className="mb-4">
            <Card className="product-card-box h-100">
              <Row className="g-0">
                <Col md={5} className="p-3 text-center">
                  <Card.Img
                    src={product.image}
                    alt={product.name}
                    style={{ maxHeight: "220px", objectFit: "contain" }}
                  />
                </Col>

                <Col md={7}>
                  <Card.Body>
                    <Card.Title className="fw-bold text-dark">
                      {product.name}
                    </Card.Title>

                    <div className="small text-muted mb-3">
                      <div>
                        <strong>Application:</strong>{" "}
                        {product.specs.application}
                      </div>
                      <div>
                        <strong>Material:</strong> {product.specs.material}
                      </div>
                      <div>
                        <strong>Finish:</strong> {product.specs.finish}
                      </div>
                      <div>
                        <strong>Color:</strong> {product.specs.color}
                      </div>
                      <div>
                        <strong>Warranty:</strong> {product.specs.warranty}
                      </div>
                      <div>
                        <strong>Supply Capacity:</strong> {product.specs.supply}
                      </div>
                    </div>

                    <button
                      className="btn btn-primary"
                      onClick={() => openEnquiryModal(product)}
                    >
                      Send Enquiry
                    </button>
                  </Card.Body>
                </Col>
              </Row>
            </Card>
          </Col>
        ))}
      </Row>

      {showEnquiry && selectedProduct && (
        <EnquiryModal
          show={showEnquiry}
          onHide={() => setShowEnquiry(false)}
          product={selectedProduct}
        />
      )}
    </Container>
  );
}

export default Cross_arm;
